export const NUMBER_OF_WEEK_DAYS = 6;
